import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import { DOC2SIGN_DOCUMENT_TYPE } from '../constants';
import { validateRFC, validateRFCFisica,getErrorsMessage } from '../utils.js';
import Dropzone from 'react-dropzone'
import SimplePagination from "./SimplePagination";
import { LangContext } from "../LangContext.jsx";
class PersonalDossierForm extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.onDrop = (files) => {
            this.setState({ file: files[0] });
            this.validateSendFile()
            this.setState({files})
        };
        this.state = {
            selectedUser: null,  
            selectedUserId:'',
            errors: 0,  
            files: [],
            file:'', 
            name: '',
            email: '',
            rfc: '',
            internalId:'',
            disabled:true, 
            successFile:false, 
            message: '',
            dossierId: null,
            dossiers: [],
            dossierDocuments: [],
            aditionalDocuments:[],
            users:[],
            documents: [],
            search: '',
            page: 1,
            total: 0,
            maxRecords: 10,
            personType:1, 
        };
        this.updateCurrentPage = this.updateCurrentPage.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.save = this.save.bind(this)
        this.changeDossiers = this.changeDossiers.bind(this)
        this.rfc = React.createRef()
        this.dossier = React.createRef()
    }
    updateCurrentPage(page){
        this.setState({page: page}, function () {
            this.getDocuments();
        });
    }
    async componentDidMount() {
        const { lang } = this.context; 
        await this.getDossiers()
        await this.getUsers()
        FormValidation.formValidation(KTUtil.getById('frm'), {
            fields: {
                dossier_id: {
                    validators: {
                        notEmpty: {
                            message: lang.get('messages.tipo_de_expediente_requerido')
                        },
                        greaterThan: {
                            min: 1,
                            message: lang.get('messages.selecciona_un_tipo_de_expediente')
                        },
                    }
                },
                selectedUser: { // New field for user selection
                    validators: {
                      notEmpty: { // Use notEmpty validator to make it required
                            message: lang.get('messages.debes_seleccionar_un_usuario') // Adjust the error message
                        },
                    }
                },
            },
            plugins: {
                trigger: new FormValidation.plugins.Trigger(),
                submitButton: new FormValidation.plugins.SubmitButton(),
                bootstrap: new FormValidation.plugins.Bootstrap({
                    eleInvalidClass: '',
                    eleValidClass: '',
                })
            },
        }).on('core.form.valid', () => {
            this.setState({ disabled: false })
            this.save()
        }); 
    } 
    getUsers= async () => { 
        axios.get('/api/users?search='+this.state.search).then(res=>{
            this.setState({users:res.data})
            const selectedUser = res.data.find((user) => user.role_id == 1);
            this.setState({selectedUserId:selectedUser.userId})
        })
    } 
    handleSearch = (e)=>{
        this.setState({search:e.target.value},function(){
            this.getUsers()
        })
    }

    isChecked = (e)=>{
        for(let i=0; i<this.state.aditionalDocuments.length; i++){
            if(this.state.aditionalDocuments[i].id == e.id){
                return true;
            }
        }
    }

    handleChange(e){
        this.setState({search: e.target.value, page: 1}, function () {
            this.getDocuments();
        });
    }

    updateStateList(e, value){
        if (e.target.checked){
            this.setState({
                aditionalDocuments: this.state.aditionalDocuments.concat([value])
            })
            } else {
            this.setState({
                aditionalDocuments : this.state.aditionalDocuments.filter(function(val)
                    {
                        return val.id!==value.id
                    }
                )
            })
        }
    }

    openModal(){
        $('[name="search"]').val('');
        this.setState({search: ''}, () => {
            this.getDocuments();
        })
    }
    getInitials = (name)=>{
    const nameList = name.split(' ')
    return nameList.length >= 2 ? `${nameList[0][0]}${nameList[1][0]}` : nameList[0][0]
    }

    async getDocuments() {
        this.setState({
            documents: []
        })
        var url = '/api/documents/aditional';
        const query = new URLSearchParams();
        query.append('page', this.state.page)
        query.append('dossier_id', this.state.dossierId)
        query.append('maxRecords', this.state.maxRecords)
        query.append('search', this.state.search)
        const qs = query.toString();
        const res =  await axios.get(url+`?${qs}`);
        const data = res.data.data;
        this.setState({documents: data, total: res.data.total});
    }

    async getDossiers() {
        const res = await axios.get('/api/dossiers/personal')
        this.setState({dossiers: res.data})
    }

    changeCountry = (event) => {
        if(this.state.rfc != ''){
            this.state.fv.revalidateField('rfc');
        }else{
            this.state.fv.resetField('rfc');
        }
        const selectedCountry = event.target.value;
        this.setState({ selectedCountry: selectedCountry} ,function(){
            this.setIdentity()
        });
    }

    async getDossierDocuments(documentId) {
        const res = await axios.get('/api/dossiers/' + documentId)
        this.setState({dossierDocuments: res.data.documents})
    }

    handlePersonTypeChange = (event) => {
        const newPersonType = event.target.value;
        this.setState({ personType: newPersonType }, () => {
            if (this.state.rfc.trim() !== '') {
                this.state.fv.revalidateField('rfc');
            } else {
                this.state.fv.resetField('rfc');
            }
            });
        };

    changeDossiers(event) { 
        this.setState({
            excelProviders: []
        })
        this.setState({ successFile: false })
        this.setState({
            aditionalDocuments: []
        })
        this.setState({ providers: [] })
        this.setState({ excelProviders: [] })
        const dossierId = event.target.value 
        const selectedDossier = this.state.dossiers.find(d => d.id == dossierId);
        this.setState({ allowMoralProviders: true }) 
        if(selectedDossier.hasAutomaticValidations == true){
            this.setState({ onlyMx: true })
        }else{
            this.setState({ onlyMx: false })
        }
        if(selectedDossier.target.id==3){
            this.setState({ allowMoralProviders: false })
        }
        if (dossierId == 0) {
            this.setState({dossierId: null, dossierDocuments: []})
        } else {
            this.dossier.current.classList.remove('is-invalid')
            this.setState({dossierId: dossierId})
            this.getDossierDocuments(dossierId)
        }
	}
    handleMessageChange = (e)=> { 
        this.setState({ message: e.target.value });
    }
    async save() {
        const { lang } = this.context; 
        KTUtil.btnWait(KTUtil.getById('btnSubmit'), 'spinner spinner-right spinner-white pr-15', "Procesando...");
        let params
            params = JSON.stringify({
                user_id: this.state.selectedUserId, 
                dossier_id: this.state.dossierId,
                aditionalDocuments: this.state.aditionalDocuments,
            }) 
        await axios.post(
            '/api/personal-dossiers',
            params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            KTUtil.btnRelease(KTUtil.getById('btnSubmit'));
            swal.fire({
                text: lang.get('messages.guardado'),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                window.location.href = '/';
            });
        })
        .catch((error) => {
            const message = getErrorsMessage(error);
            KTUtil.btnRelease(KTUtil.getById('btnSubmit'));
            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            }).then(function() {
                KTUtil.scrollTop();
            });
        });
    } 
    handleUserSelection = (userId) => {
        this.setState({ selectedUserId: userId });
    };

    render() {
        const { lang } = this.context; 
        const { selectedUser } = this.state; 
        const files = this.state.files.map(file => (
            <li key={file.name}>
                {file.name} - {file.size} bytes
            </li>
        ));
        return (
            <div>
                <div className="d-flex flex-column-fluid  ">
                    <div className="container">
                        <div className="alert alert-soft-warning  mb-3 d-flex align-items-center" role="alert">
                                <div>
                                    <span className="flaticon2-warning mr-2 icon-3x"></span>
                                </div>
                                <div>
                                    <h3>{lang.get('messages.nota')}</h3> 
                                    {lang.get('messages.solo_estaran_disponibles_plantillas_de_expedientes_que_su_relacion_sea_propio')}.
                                </div>
                        </div>
                        <div className="card card-ustom gutter-b">
                            <div className="card-body">
                                <h5 className="text-dark font-weight-bold mb-10">
                                    Datos del expediente
                                    <br/>
                                    <small className="text-muted font-weight-bold">{lang.get('messages.anade_los_campos_que_requieres_que_el_colaborador_ingrese')}</small>
                                </h5>
                            <form id="frm">
                                <div className="row justify-content-center text-left">
                                    <div className="col-sm-6 align-self-center form-group">
                                        <label className="text-left">{lang.get('messages.plantilla_de_expediente')}</label>
                                        <select ref={this.dossier} className="form-control form-control-solid" id="dossier_id" name="dossier_id" onChange={this.changeDossiers}>
                                            <option value="0">-- {lang.get('messages.seleccionar')} --</option>
                                            { ( !this.props.permissions.providers_list.includes('all')  ) &&
                                            <>
                                                {this.state.dossiers?.map((d, i) => {
                                                    return <option key={i} value={d.dossier.id}>{d.dossier.title}</option>;
                                                })}
                                            </>
                                            }
                                            { ( this.props.permissions.providers_list.includes('all')  ) &&
                                            <>
                                                {this.state.dossiers?.map((d, i) => {
                                                    return <option key={i} value={d.id}>{d.title}</option>;
                                                })}
                                            </>
                                            }
                                        </select>
                                    </div> 
                                    <div className="col-sm-6 align-self-center form-group">
                                        <div className="mt-0 mt-sm-8">
                                            <label>{ this.state.dossierId != null ? "Hay " + this.state.dossierDocuments.length + " documentos en esta plantilla de expediente" : "" }</label>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <label className="text-left">{lang.get('messages.listado_de_documentos_a_solicitar')}</label>
                                        <div className="col-12 pt-6 pb-2 pr-6 pl-6 card bg-light-light min-h-200px">
                                            {this.state.dossierDocuments.map((d, i) => {
                                                return <div key={i} className="mb-2"><span className="fas fa-check text-primary"></span>&nbsp; {d.title}</div>
                                            })}
                                            { this.state.aditionalDocuments.length > 0  ?
                                            <div><hr/>
                                            <label className="text-left text-left text-dark font-weight-bold">Listado de documentos adicionales</label></div>
                                            : "" }
                                            {this.state.aditionalDocuments.map((d, i) => {
                                                return <div key={i} className="mb-2"><span className="fas fa-check text-primary"></span>&nbsp; {d.title}</div>
                                            })}
                                            { this.state.dossierId != null ?
                                            <div className="text-center mt-6">
                                                <a href="" onClick={this.openModal.bind(this)} className="btn btn-success btn-sm font-weight-bolder px-5" data-toggle="modal" data-target="#modal">
                                                    <span className="svg-icon svg-icon-md">
                                                        <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                                                <polygon points="0 0 24 0 24 24 0 24"/>
                                                                <path d="M5.85714286,2 L13.7364114,2 C14.0910962,2 14.4343066,2.12568431 14.7051108,2.35473959 L19.4686994,6.3839416 C19.8056532,6.66894833 20,7.08787823 20,7.52920201 L20,20.0833333 C20,21.8738751 19.9795521,22 18.1428571,22 L5.85714286,22 C4.02044787,22 4,21.8738751 4,20.0833333 L4,3.91666667 C4,2.12612489 4.02044787,2 5.85714286,2 Z" fill="#000000" fillRule="nonzero" opacity="0.3"/>
                                                                <rect fill="#000000" x="6" y="11" width="9" height="2" rx="1"/>
                                                                <rect fill="#000000" x="6" y="15" width="5" height="2" rx="1"/>
                                                            </g>
                                                        </svg>
                                                    </span>
                                                    {lang.get('messages.agregar_nuevo_documento')}
                                                </a>
                                            </div>
                                            : "" }
                                            { this.state.dossierId != null ?
                                            <div className="modal fade" id="modal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
                                                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                                                    <div className="modal-content" style={{ background: '#f5f5f5' }}>
                                                        <div className="modal-body px-15 py-10">
                                                            <h5 className="text-dark font-weight-bold my-1 mr-5">{lang.get('messages.solicitar_nuevos_documentos')}</h5>
                                                            <div className="text-muted">{lang.get('messages.selecciona_los_nuevos_documentos_que_seran_agregados_a_este_expediente')}</div>
                                                            <div className="card card-custom gutter-b my-5">
                                                                <div className="card-header border-0 pt-6">
                                                                    <h3 className="card-title align-items-start flex-column">
                                                                        <span className="card-label font-weight-bolder font-size-h4 text-dark-75">{lang.get('messages.tipos_de_documentos')}</span>
                                                                        <span className="text-muted mt-3 font-weight-bold font-size-lg">{this.state.total} {lang.get('messages.documentos_disponibles')}.
                                                                        </span>
                                                                    </h3>
                                                                    <div className="row justify-content-end">
                                                                        <div className="col-12">
                                                                            <div className="input-icon">
                                                                                <input onChange={(e)=>this.handleChange(e)} name="search"type="text" className="form-control" placeholder={lang.get('messages.buscar')} />
                                                                                <span>
                                                                                    <i className="flaticon2-search-1 text-primary icon-md"></i>
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="card-body pt-5">
                                                                    {this.state.documents.map((o, i) => {
                                                                        return <div key={i}>
                                                                            <div className="d-flex align-items-center py-2">
                                                                                <div className="symbol symbol-40 symbol-white">
                                                                                    <span className="symbol-label d-flex justify-content-start w-45px ml-n1">
                                                                                    <div className="checkbox-inline mr-5">
                                                                                        <label className={`checkbox checkbox-outline mb-2 ${o.type_id == DOC2SIGN_DOCUMENT_TYPE ? 'checkbox-disabled' : ''}`}>
                                                                                            <input key={o}
                                                                                                name='list'
                                                                                                type='checkbox'
                                                                                                defaultChecked={this.isChecked(o)}
                                                                                                onClick={(e)=>this.updateStateList(e,o)}
                                                                                                label='Add'
                                                                                                className='listTour'
                                                                                                disabled={o.type_id == DOC2SIGN_DOCUMENT_TYPE}
                                                                                            />
                                                                                            <span className="w-25px h-25px mt-2 rounded-0"></span>
                                                                                        </label>
                                                                                    </div>
                                                                                    </span>
                                                                                </div>
                                                                                <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2">
                                                                                    <a href={"/documents/" + o.id + "/edit"} className={"text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg " + (o.active==0 ? "text-muted" : "")}>{o.title}</a>
                                                                                    {o.active == 0 ? <span style={{ width : "60px" }} className="label label-sm label-light-dark label-inline font-weight-bold"><span className="font-size-xs">Borrador</span></span>: '' }
                                                                                </div>
                                                                                <a href={"/documents/" + o.id + "/edit"}>
                                                                                    <button className="btn btn-icon btn-light btn-xs">
                                                                                        <i className={"flaticon2-right-arrow icon-sm " + (o.active==0 ? "text-muted" : "text-primary")}></i>
                                                                                    </button>
                                                                                </a>
                                                                            </div>
                                                                        </div>
                                                                    })}
                                                                </div>
                                                                {this.state.total > this.state.maxRecords  &&
                                                                    <SimplePagination
                                                                    updateCurrentPage={this.updateCurrentPage}
                                                                    currentPage={this.state.page}
                                                                    totalFiles={this.state.total}
                                                                    split={this.state.maxRecords} />
                                                                }
                                                            </div>
                                                            <br />
                                                            <div className="text-center">
                                                                <button data-dismiss="modal" className="btn btn-success font-weight-bolder px-10" >
                                                                    {lang.get('messages.cerrar')}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            : "" }
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="row mt-3  ">
                                        <div className="col-md-7">
                                        <h5 className="text-dark font-weight-bold mb-10">
                                        {lang.get('messages.datos_del_colaborador')}
                                            <br/>
                                            <small className="text-muted font-weight-bold">{lang.get('messages.escoge_de_la_lista_el_usuario_colaborador_que_tomara_cargo_de_este_expediente_propio')}. 
                                            {lang.get('messages.en_caso_de_que_quieras_agregar_a_un_nuevo_colaborador_primero_deberas_invitarlo_desde_el_boton_agregar_nuevo_usuario_')}.</small>
                                        </h5>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-3">
                                            <div className="input-icon">
                                                <input
                                                onChange={(e) => this.handleSearch(e)}
                                                type="text"
                                                className="form-control"
                                                placeholder={lang.get('messages.buscar_usuarios')} />
                                                <span>
                                                    <i className="flaticon2-search-1 text-primary icon-md"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div> 
                                    {this.state.users?.map((user) => (
                                    <div key={user.id} className="d-flex  align-items mb-3">
                                        <input
                                            className="mr-2"
                                            type="radio" 
                                            id="selectedUser"
                                            name="selectedUser"
                                            value={user.userId}
                                            checked={user.userId === this.state.selectedUserId}
                                            onChange={() => this.handleUserSelection(user.userId)}
                                        />
                                        <div className="symbol symbol-40 mr-2">
                                        {user.role_id == 1 &&
                                            <div className="symbol-label bg-primary text-white font-weight-bolder">
                                            {this.getInitials(user.name)}
                                        </div>
                                        }
                                        {user.role_id != 1 &&
                                            <div className="symbol-label bg-primary-o-40 text-primary font-weight-bolder">
                                            {this.getInitials(user.name)}
                                        </div>
                                        }
                                        </div>
                                        <div className="mr-2">  <strong> {user.name}  {user.role_id == 1 && '(Solicitante)' }</strong>
                                            <div class="text-muted"> {user.email}  </div>
                                        </div>
                                    </div>
                                    ))} </div>
                            </form> 
                        </div>
                        </div>
                        <div className="row justify-content-end mt-6">
                            <div className="col-sm-4 text-right">
                                <a href="/" className="btn btn-lg btn-secondary">
                                    {lang.get('messages.cancelar')}
                                </a>
                                <button id="btnSubmit"  form="frm"  type="submit" className="btn btn-lg btn-primary ml-4 text-white">
                                    {lang.get('messages.crear_expediente_propio')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PersonalDossierForm;

if (document.getElementById('PersonalDossierForm')) {
    ReactDOM.render(<PersonalDossierForm />, document.getElementById('PersonalDossierForm'));
}
